// Vetted list of Australian universities (public and major private institutions)
// Source: Australian Government/TEQSA listings + common usage
export const AU_UNIVERSITIES: string[] = [
  // Group of Eight
  'Australian National University',
  'The University of Melbourne',
  'The University of Sydney',
  'The University of Queensland',
  'The University of Western Australia',
  'The University of Adelaide',
  'Monash University',
  'UNSW Sydney',

  // Australian Technology Network & others
  'RMIT University',
  'University of Technology Sydney',
  'Queensland University of Technology',
  'University of South Australia',
  'Curtin University',
  'Swinburne University of Technology',

  // Innovative Research Universities and others
  'Griffith University',
  'Macquarie University',
  'La Trobe University',
  'University of Newcastle',
  'Western Sydney University',
  'Deakin University',
  'University of Wollongong',
  'University of Tasmania',
  'James Cook University',
  'Charles Darwin University',
  'University of New England',
  'University of Canberra',
  'Victoria University',
  'Federation University Australia',

  // Regional
  'Charles Sturt University',
  'Southern Cross University',
  'CQUniversity',

  // Catholic and private
  'Australian Catholic University',
  'Bond University',
  'University of Divinity',
];
